import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const iconStyles = xcss({
	backgroundColor: 'color.background.neutral',
	height: '20px',
	borderRadius: 'radius.xsmall',
	border: `${token('border.width')} solid transparent`,
	color: 'color.text.subtle',
	font: 'font.body.small',
	display: 'flex',
	alignItems: 'center',
	paddingInline: 'space.050',
	paddingBlock: '0',
});

// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
export const ControlIcon: () => React.JSX.Element = () => <Box xcss={iconStyles}>Ctrl</Box>;
